// ----------------------------------------------------------------------

export default function Autocomplete(theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.dropdown,
          background: "hsla(0, 0%, 5%, 0.8) !important", // semi-transparent dark background
          backdropFilter: "blur(10px) !important",       // blur effect
          WebkitBackdropFilter: "blur(10px) !important", // Safari support
          borderRadius: '8px !important',
        },
        listbox: {
          padding: theme.spacing(0, 1),
          '& .MuiAutocomplete-option': {
            padding: theme.spacing(1),
            margin: theme.spacing(1, 0),
            borderRadius: theme.shape.borderRadius,
          },
        },
      },
    },
  };
}
